import { Injectable } from '@angular/core';
import {
  ProcessErrorCodeAdapterService,
  ProcessErrorCodeFn,
} from 'src/app/components/scrolling-list/services/process-error-code-adapter.service';
import { DisplayApiService } from 'src/app/api/services/display-api.service';

@Injectable({
  providedIn: 'root',
})
export class DisplaySummaryService {
  apiError?: string;
  summary?: DisplaySummary;
  summaryLoading?: boolean;

  private processErrorCode: ProcessErrorCodeFn;

  constructor(
    private displayApiService: DisplayApiService,
    processErrorCodeAdapter: ProcessErrorCodeAdapterService,
  ) {
    this.processErrorCode = processErrorCodeAdapter.createCallable();
  }

  loadSummary(includeSubcompanies: boolean = false): Promise<void> {
    this.summary = undefined;
    this.summaryLoading = true;

    return this.displayApiService
      .summary(null, includeSubcompanies)
      .then((summary) => {
        this.summary = summary;
      })
      .catch((err) => {
        this.apiError = this.processErrorCode(err);
        console.log('Error requesting display summary', err);
      })
      .finally(() => {
        this.summaryLoading = false;
      });
  }
}

export interface DisplaySummary {
  online: number;
  offline: number;
  scheduledUnlicensed: number;
}
